namespace TabAurous.ECommerce {
    export namespace ECommExchangeSelectItemsService {
        export const baseUrl = 'ECommExchange/ECommExchangeSelectItems';

        export declare function List(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<ECommExchangeItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ECommExchange/ECommExchangeSelectItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ECommExchangeSelectItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
